export default () => {
    const blogPage = document.querySelector('.blogPage');

    if(!blogPage) return;

    initializeBlogArchiveOrderby();
    initializeInfiniteScroll();
}

const initializeBlogArchiveOrderby = () => {
    const orderByWrapper = document.querySelector('.blogPage__orderby');

    if(!orderByWrapper) return;

    orderByWrapper.addEventListener('click', () => {
        orderByWrapper.classList.toggle('active');
    })

    const options = orderByWrapper.querySelectorAll('.blogPage__orderby__option');
    const formSelect = orderByWrapper.querySelector('select[name="sort"]');
    options.forEach(option => {
        option.addEventListener('click', () => {
            if(option.getAttribute('checked')) return;
            formSelect.value = option.getAttribute('data-value');
            formSelect.parentNode.submit();
        })
    })
}

const initializeInfiniteScroll = () => {
    const navigation = document.querySelector('.blogPage__nav');
    const content = document.querySelector('.blogPage__list');
    if(!navigation || !content) return;

    let loading = false;
    let noMorePosts = false;

    const infiniteScroll = new IntersectionObserver((entries) => {
        if(noMorePosts || loading) return;

        if(entries[0].isIntersecting) {
            navigation.classList.add('active');
            loading = true;
            let inputs = navigation.querySelectorAll('input[type="hidden"]');
            const formData = inputsToFormData(inputs);
            fetch(ajax.url, {
                method: 'POST',
                body: formData,
            })
                .then(res => res.json())
                .then(data => {
                    if(data.success === false) throw new Error(data.data.html);
                    content.innerHTML += data.data.html;
                    if(Number(formData.get('page')) + 1 === data.data.max_pages) {
                        noMorePosts = true;
                    } else {
                        navigation.querySelector('input[name="page"]').value = Number(formData.get('page')) + 1;
                    }
                })
                .catch(err => {
                    noMorePosts = true;
                })
                .finally(() => {
                    loading = false;
                    navigation.classList.remove('active');
                })
        } else {
            navigation.classList.remove('active');
        }
    });
    infiniteScroll.observe(navigation);
}

const inputsToFormData = (inputs) => {
    const formData = new FormData();
    inputs.forEach(input => {
        formData.append(input.name, input.value);
    })
    return formData;
}